import { Station } from '@app/core/types/stations';
import {
  AuditSupportBulkUploadAvgFilesMutationRequest,
  AuditSupportMinUploadAvgResultDto,
  useAuditSupportBulkUploadAvgFiles,
} from '@mi-front/api-v2';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { AvgPreview } from './AvgPreview';

export function AvgUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      AuditSupportMinUploadAvgResultDto,
      { data: AuditSupportBulkUploadAvgFilesMutationRequest }
    >
      station={station}
      accept=".avg,.AVG,.avg.txt,.AVG.TXT,text/plain"
      fileType="AVG"
      useUploadMutation={useAuditSupportBulkUploadAvgFiles}
      renderPreview={(data) => <AvgPreview entries={data.entries ?? []} />}
    />
  );
}
